exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ix-table[data-v-090c18a4] {\n    width: 100%;\n}\n.form-control-sm[data-v-090c18a4] {\n    height: 32px;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n}\n.text-muted[data-v-090c18a4] {\n    opacity: 0.6;\n}\n", ""]);

// exports
